export const environment = {
    production: process.env.NODE_ENV === 'production',
    hmr: false,
    serverApiUrl: 'https://prod-api.routemagic.co.uk/',
    env: 'prod',
    heremapsCredentials: {
        apiKey: '9T-n-T9TIx5AnpOJYZA4dcsNtxMqMd73xtD1jlLL6wo'
    },
    googleMaps: {
        apiKey: 'AIzaSyCBvI2pbMwTbXTZ2p0vVco3e0ok7fNQkeU'
    },
    graphhopper: {
        apiKey: '963a3f57-7782-4be3-9f2b-10a4df31ed02'
    },
    logUrl: 'https://lwk2e2mbqwaefp46ubrywqsxx40iombm.lambda-url.eu-west-1.on.aws/',
    enableNewRelic: false,
    newrelic: {
        init: {distributed_tracing: {enabled: true}, privacy: {cookies_enabled: true}},
        loader_config: {
            accountID: '3458937',
            trustKey: '3458937',
            agentID: '538679740',
            licenseKey: 'NRJS-5eb9afcf1921f2210b6',
            applicationID: '538679740'
        },
        info: {
            beacon: 'bam.eu01.nr-data.net',
            errorBeacon: 'bam.eu01.nr-data.net',
            licenseKey: 'NRJS-5eb9afcf1921f2210b6',
            applicationID: '538679740',
            sa: 1
        }
    },
    heap: {
        projectId: '1360311418'
    },
    stockAnalyticsLink:
        'https://lookerstudio.google.com/embed/reporting/fca4cc6d-d615-4b22-be29-db365beae8cb/page/FWmtD?params=%7B"df41":"include%25EE%2580%25800%25EE%2580%2580IN%25EE%2580%2580tenant"%7D',
    //make sure when you add a new api key, you add it to the csvBoxKeys object accross env.ts, env.prod.ts, env.staging.ts and ensure that it is whitelisted on the CSVbox admin panel
    csvBoxKeys: {
        saleOrder: {
            csvBoxLicenceKey: '8AE1RRgPOftbLxFTajk9byMVPOVmh6',
            csvBoxPackageImportLicenceKey: 'pNIyTxQg3QC7GR1ArVmQv3aK92MgZp',
            csvBoxItemsExtractLicenceKey: 'JpNC26vo3PFRfty5SkZOhHdppkAcv5'
        },
        payment: {
            csvBoxLicenceKey: 'ObkOr0qsHTIVXNvUEVWIA7IZCJ5ijX'
        },
        routePlanner: {
            csvBoxLicenceKey: 'AvHIxs8WIMvd5sYA10p1CkQXJ5w3vk'
        },
        routeSchedule: {
            csvBoxLicenceKey: 'o6NTWa1bZmvS9bTdNeGZk5ONndprco'
        },
        serviceOrder: {
            csvBoxLicenceKey: '17WeVPZbAAzCjzG33Bebpp6TJHgw3f'
        },
        branch: {
            csvBoxLicenceKey: 'cz1DZ2n6B8IfJOq6YVojPJHBABKvps'
        },
        company: {
            csvBoxLicenceKey: 'hvNItWotdXExBPzmA6hx5aiPRP06a5'
        },
        customer: {
            csvBoxLicenceKey: '1f0GIBCmGrQaoZ71ZuUbsXQdvSpBxK',
            csvBoxDeliveryPointImportLicenceKey: 'j3hYqvGmpUqgo1DNjPQe3yBNCeVDQ5',
            csvBoxCustomFieldValuesImportLicenceKey: 'Ncg4L9FWDV90qtyv7m7ZRYpVVEK3Ux',
            csvBoxCustomerDefaultProductsImportLicenceKey: '2mj9gikCTamuLbNKHXbZAK8TvZYKJM'
        },
        employee: {
            csvBoxLicenceKey: 'Udl47M4aPhrCnul5dhdVRVfIxz1xpQ'
        },
        incomingInventory: {
            csvBoxLicenceKey: 'cXfXnfS5h62tkSQISOLYzlZv2gkMEu'
        },
        loadOrder: {
            csvBoxLicenceKey: '6MNPXGdBrbNcJxKWqqgLpDlwCZDUXI'
        },
        priceList: {
            csvBoxLicenceKey: 'lbjqJhxTzJwtTXUpy7S94PmUVRrv22'
        },
        product: {
            csvBoxLicenceKey: 'ixI2VuLygabefb7waCGZnnsSSeSPiO',
            csvBoxCustomFieldValuesLicenceyKey: '4Wmii9gGNNXJzyFyWhmD1WjlvtEnwe'
        },
        productClass: {
            csvBoxLicenceKey: 'R2L7k0gxlka4nkRjXHgIzfiAcp5toS'
        },
        productGroup: {
            csvBoxLicenceKey: '94qTF7e0tlqOQjwcHsl2Ys57fMoBGC'
        },
        productImeiTrack: {
            csvBoxLicenceKey: '4BA05JMjh6cb2Rll782nsLwGdKPDzy'
        },
        purchaseOrder: {
            csvBoxLicenceKey: 'C8tADzvq0PSTzk036TUbmu4UxrRVRM',
            csvBoxItemsExtractLicenceKey: 'JpNC26vo3PFRfty5SkZOhHdppkAcv5'
        },
        route: {
            csvBoxLicenceKey: 'udQhd1km8GSxQxuszkpty4uoZxgSOY'
        },
        standingLoadOrder: {
            csvBoxLicenceKey: 'xHSaP4yTeQRr8ltuhs4EYCKe4RbPIp'
        },
        supplier: {
            csvBoxLicenceKey: 'Y67XrXU3FhCYSQDsKx8QoCBoycTDoR'
        },
        vehicle: {
            csvBoxLicenceKey: 'SxJw7SvM286w72XucLLl3LltqgAKl3'
        },
        warehouse: {
            csvBoxLicenceKey: 'l80poao3aUaYBSGCWxlRRAT37qFD7k'
        },
        warehouseTransfer: {
            csvBoxLicenceKey: 'i5f89t3hB2QB175L6jS6bztxmHI4dx'
        },
        workshop: {
            csvBoxLicenceKey: 'WEvgwgLlz9Ac09jSDmwT9fjXZPjrAb'
        },
        bin: {
            csvBoxLicenceKey: 'Lw9u8D4H0lJbo127TE12t2k6mzEt3O'
        },
        productAttributeType: {
            csvBoxLicenceKey: 'V9OeEmOFh4cHTfqgUJqoDyUSblakza'
        },
        surveyAllocation: {
            csvBoxLicenceKey: 'Qn1JqjyCCydRmKFZDOydSyx2TwC0Nu'
        },
        invoiceAllocation: {
            csvBoxLicenceKey: 'DyLcvtrkwAM75aNHiqNLUNB2Z3bvxk'
        },
        invoicePaymentAllocation: {
            csvBoxLicenceKey: 'aqh5IpGPvnHHZ8nV1RAczK6aWnwBOV'
        }
    },
    routemagicAssistant: {
        enabled: false
    }
};
